import { render, staticRenderFns } from "./appFrame.vue?vue&type=template&id=980d6de4&scoped=true"
import script from "./appFrame.vue?vue&type=script&lang=js"
export * from "./appFrame.vue?vue&type=script&lang=js"
import style0 from "./appFrame.vue?vue&type=style&index=0&id=980d6de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980d6de4",
  null
  
)

export default component.exports